import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/LegalPage";
import { buildSeoMeta } from "@/lib/seo";

export const Route = createFileRoute("/regulamin")({
  head: () =>
    buildSeoMeta({
      title: "Regulamin | SyncTech",
      description: "Regulamin świadczenia usług SyncTech — zasady korzystania z serwisu i usług wdrożeniowych.",
      path: "/regulamin",
    }),
  component: Regulamin,
});

function Regulamin() {
  return (
    <LegalPage title="Regulamin świadczenia usług" lastUpdated="6 maja 2026">
      <h2>§1. Postanowienia ogólne</h2>
      <p>
        Niniejszy regulamin określa zasady świadczenia usług przez <strong>Piotr Ziółkowski</strong>{" "}
        prowadzącego działalność nierejestrowaną pod marką <strong>SyncTech</strong>, z siedzibą
        w <strong>Warszawie (woj. mazowieckie)</strong> (dalej: „Usługodawca").
      </p>
      <p>
        Usługodawca korzysta ze zwolnienia podmiotowego z VAT na podstawie art. 113 ust. 1 i 9 ustawy z dnia 11 marca 2004 r. o podatku od towarów i usług. Rozliczenie podatku dochodowego: ryczałt ewidencjonowany 12%.
      </p>

      <h2>§2. Definicje</h2>
      <ul>
        <li><strong>Usługobiorca</strong> — osoba fizyczna, osoba prawna lub jednostka organizacyjna korzystająca z usług;</li>
        <li><strong>Usługi</strong> — wdrożenia, integracje, abonament wsparcia i konsultacje e-commerce;</li>
        <li><strong>Serwis</strong> — strona internetowa pod adresem synctech.pl.</li>
      </ul>

      <h2>§3. Zakres usług</h2>
      <ul>
        <li>wdrożenia platform e-commerce (Baselinker, SellAsist, Shopify, Shoper, ShopGold, PrestaShop);</li>
        <li>integracje z marketplace'ami, ERP, kurierami i bramkami płatniczymi;</li>
        <li>kampanie reklamowe Google Ads i Facebook Ads;</li>
        <li>konfiguracja analityki (GA4, Pixel, Conversions API);</li>
        <li>abonament wsparcia technicznego;</li>
        <li>konsultacje i audyty e-commerce.</li>
      </ul>

      <h2>§4. Zawarcie umowy</h2>
      <p>
        Umowa zawierana jest na podstawie indywidualnej oferty po konsultacji lub poprzez zakup pakietu
        za pośrednictwem operatora płatności online. Szczegóły zlecenia (zakres, harmonogram, wynagrodzenie)
        określa odrębna umowa lub potwierdzenie zlecenia.
      </p>

      <h2>§5. Wynagrodzenie i płatności</h2>
      <p>
        Wynagrodzenie ustalane jest indywidualnie lub zgodnie z cennikiem pakietów. Wszystkie ceny są kwotami
        do zapłaty (Usługodawca jest zwolniony z VAT). Rozliczenie następuje po zrealizowaniu wdrożenia na
        podstawie faktury z 7-dniowym terminem płatności. Akceptujemy przelew tradycyjny oraz płatności online.
      </p>

      <h2>§6. Prawo odstąpienia (konsumenci)</h2>
      <p>
        Konsument ma prawo odstąpić od umowy w terminie 14 dni bez podania przyczyny, chyba że świadczenie usługi
        rozpoczęło się za jego wyraźną zgodą przed upływem tego terminu — wówczas prawo odstąpienia wygasa po pełnym wykonaniu usługi.
      </p>

      <h2>§7. Reklamacje</h2>
      <p>
        Reklamacje można zgłaszać na adres <strong>kontakt@synctech.pl</strong>.
        Reklamacja zostanie rozpatrzona w terminie 14 dni roboczych.
      </p>

      <h2>§8. Postanowienia końcowe</h2>
      <p>
        W sprawach nieuregulowanych regulaminem zastosowanie mają przepisy prawa polskiego, w szczególności Kodeks cywilny.
        Spory rozstrzyga sąd właściwy dla siedziby Usługodawcy.
      </p>
    </LegalPage>
  );
}
